import { Observable, Subject, combineLatest } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { createSymbol } from "@zyzgroup/core-common";
import { useLocalStorage } from "./useLocalStorage";
import { useMatchMedia$ } from "./useMatchMedia";
import { atomWriteAttribute } from "./useAttribute";

// import "@zyzgroup/core-web/dist/theme.css";
// xg-blue:信鸽蓝 xg-red:信鸽红 xg-green:信鸽绿 ks-green:昆山绿 yz-green:扬州绿
export type ColorPattern =
  | "xg-blue"
  | "xg-red"
  | "xg-green"
  | "ks-green"
  | "yz-green";

export type ThemeType = "dark" | "light";

const { get: getLocalStorage, set: setLocalStorage } = useLocalStorage(
  createSymbol("theme")
);

const localBi$ = new Subject<ThemeType | undefined>();
const local$ = localBi$.pipe(startWith(undefined));

function setThemeInDOM(theme: ThemeType) {
  switch (theme) {
    case "dark":
      document.documentElement.classList.add("dark");
      atomWriteAttribute(document.documentElement, "data-theme", "dark");
      break;
    case "light":
    default:
      document.documentElement.classList.remove("dark");
      atomWriteAttribute(document.documentElement, "data-theme", "light");
      break;
  }
}

export function setTheme(theme: ThemeType): ThemeType {
  setLocalStorage(theme);
  setThemeInDOM(theme);
  localBi$.next(theme);
  return theme;
}

export function toggleTheme(): ThemeType {
  return setTheme(getLocalStorage() == "dark" ? "light" : "dark");
}

export function getTheme$(): Observable<ThemeType> {
  return combineLatest([
    local$,
    useMatchMedia$("(prefers-color-scheme: dark)")
  ]).pipe(
    map(([theme, matchMediaDark]) => {
      if (theme) {
        return theme;
      }
      theme = getLocalStorage();
      if (!theme) {
        // 如果用户没有初始设置过：浏览器会获取「系统默认设置」
        theme = matchMediaDark ? "dark" : "light";
      }
      setLocalStorage(theme);
      setThemeInDOM(theme);
      return theme;
    })
  );
}

export function getCSSVar(name: string, defaultValue = ""): string {
  return (
    getComputedStyle(document.documentElement).getPropertyValue(name) ||
    defaultValue
  );
}

export function setCSSVar(name: string, value: string): void {
  // getComputedStyle(document.documentElement).setProperty(name, value);
  document.documentElement.style.setProperty(name, value);
}
